import { httpsCallable } from 'firebase/functions';

import { functions } from '../index';

interface VerifyMerchantCode {
  shop: string;
  code: string;
}

export enum VerifyCodeStatusCodes {
  AccessDenied = 'Access Denied',
  Success = 'Success'
}

export const verifyMerchantCode = async (data: VerifyMerchantCode): Promise<{ status: VerifyCodeStatusCodes }> => {
  const result = await httpsCallable<VerifyMerchantCode, { status: VerifyCodeStatusCodes }>(functions, 'verifyMerchantCodeV2')(data);

  return result.data;
};

export const createCarrierServiceAndOrderWebhook = async (): Promise<boolean> => {
  const result = await httpsCallable<unknown, boolean>(functions, 'createCarrierServiceAndOrderWebhookV2')();

  return result.data;
}

export const createOrderWebhook = async (): Promise<boolean> => {
  const result = await httpsCallable<unknown, boolean>(functions, 'createOrderWebhookV2')();

  return result.data;
}

interface VerifyScopes {
  shop: string;
}

export const verifyScopes = async (data: VerifyScopes): Promise<{ shouldReAuth: boolean; }> => {
  const result = await httpsCallable<VerifyScopes, { shouldReAuth: boolean; }>(functions, 'verifyScopesV2')(data);

  return result.data;
};
